
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
const defaultDelay = 1000;
@Component({})
export default class BgAreaSelect extends Vue {
  /** 总数 */
  @Prop({ required: false, default: 60 }) count?: number;
  /** 最小值 */
  @Prop({ required: false, default: 0 }) min?: number;
  /** 每次计数的幅度 */
  @Prop({ required: false, default: 1 }) step?: number;
  /** 每次计数间隔时间 ms */
  @Prop({ required: false, default: defaultDelay }) delay?: number;
  /** 显示文字格式化 fn */
  @Prop({ required: false }) format?: (count: number) => string;
  @Prop({ required: false, default: false }) auto?: boolean;
  @Prop({ required: false, default: "" }) originText?: string;
  @Prop({ required: false }) beforeClick?:
    | (() => boolean)
    | (() => Promise<boolean>);
  current = 0;
  countdownTimer = 0;
  running = false;
  get text(): string {
    if (this.running) {
      if (typeof this.format === "function") {
        return this.format(this.current);
      }
      return `${this.current}`;
    } else {
      return this.originText || `${this.count}`;
    }
  }
  @Watch("count")
  handleCountChange() {
    this.initCurrent();
  }
  created() {
    this.initCurrent();
  }
  mounted() {
    if (this.auto) {
      this.countdown();
      this.$emit("countdown");
    }
  }
  initCurrent() {
    if (typeof this.count === "number") {
      this.current = this.count;
    }
  }
  async handleClick() {
    if (typeof this.beforeClick === "function") {
      const beforeClickRes = this.beforeClick();
      if (beforeClickRes instanceof Promise) {
        const validateRes = await beforeClickRes;
        if (!validateRes) {
          return;
        }
      } else if (!beforeClickRes) {
        return;
      }
    }
    this.countdown();
    this.$emit("countdown");
  }
  countdown() {
    clearTimeout(this.countdownTimer);
    const delay = this.delay || defaultDelay;
    this.running = true;
    this.countdownTimer = window.setTimeout(() => {
      if (
        this.count !== undefined &&
        this.min !== undefined &&
        this.step !== undefined &&
        this.current > this.min
      ) {
        let newVal = this.current - this.step;
        if (newVal <= this.min) {
          newVal = this.min;
          this.current = newVal;
          this.running = false;
          this.initCurrent();
        } else {
          this.current = newVal;
          this.countdown();
        }
      } else {
        this.running = false;
        this.initCurrent();
      }
    }, delay);
  }
  reset() {
    this.initCurrent();
  }
}
